import { render } from "./NcrmWorkflowAiCompatibilitySettings.vue?vue&type=template&id=7aa70183"
import script from "./NcrmWorkflowAiCompatibilitySettings.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowAiCompatibilitySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__